export interface ITeam {
  courseHandicap?: number;
  enrollments: number[];
  event: number;
  flight: number;
  handicap: string;
  id: number;
  isValid: boolean;
  order: number;
  customName: string;
}

export interface IAdminEventTeamsStore {
  [eventId: number]: ITeam[];
}

export const adminEventTeamsStore: IAdminEventTeamsStore = {};
